/**
 * OrbDocDownloadsSkillsENOrbDocDownloadsSkillsENPage
 *
 * Page component for OrbDocDownloadsSkillsENOrbDocDownloadsSkillsENPage
 * Path: /docs/downloads/skills
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocDownloadsSkillsENDocScreenView as __OrbDocDownloadsSkillsENDocScreenView } from '@/components/traits/OrbDocDownloadsSkillsENDocScreenView';
import { OrbDocDownloadsSkillsENDocAnalyticsView as __OrbDocDownloadsSkillsENDocAnalyticsView } from '@/components/traits/OrbDocDownloadsSkillsENDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocDownloadsSkillsENOrbDocDownloadsSkillsENPageProps {
  // Add any page-level props here
}

export function OrbDocDownloadsSkillsENOrbDocDownloadsSkillsENPage(_props: OrbDocDownloadsSkillsENOrbDocDownloadsSkillsENPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"Agent skills","description":"Teach any coding agent to write valid .lolo, with the same catalog and checks the compiler uses.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/downloads/skills"},{"locale":"ar","path":"/ar/docs/downloads/skills"},{"locale":"sl","path":"/sl/docs/downloads/skills"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocDownloadsSkillsENDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocDownloadsSkillsENDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocDownloadsSkillsENOrbDocDownloadsSkillsENPage;
